export const ERROR_MSG = {
  forbidden: 'Недостаточно прав для выполнения операции',
  internal: 'Что-то пошло не так...'
};
